var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"week-picker"},_vm._l((_vm.weeks),function(week){return _c('span',{key:week.id,class:{
            'is-selected': _vm.weekCache.includes(week.id)
        },on:{"click":function($event){return _vm.saveWeek(week)}}},[_vm._v(_vm._s(week.name))])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }